import { useSelector } from "react-redux";
import AccessDenied from "../component/AccessDenied";
import { isTaskAllowed } from "../utils/isTaskAllowed";
import GalleryImages from "../component/GalleryImages";

const Gallery = () => {
    const { admin } = useSelector((state) => state.auth);

    if(admin?.email !== "admin@thriftyx.com" &&
        !isTaskAllowed("Gallery", admin?.assignedWork)) return (<AccessDenied />)

    return (<GalleryImages />)
}
export default Gallery;